export default __webpack_public_path__ + "audios/39053091d9c848fb4dfe1a41364fb931.mp3";